import {FC, useMemo} from 'react';
import useTimer, {getDatesDifferenceInSeconds} from '../../hooks/useTimer';

type ProcessDetailsTimerProps = {
  startedAt?: string,
  completedAt?: Nullable<string>,
  totalTimeLabel: string
};

const ProcessDetailsTimer: FC<ProcessDetailsTimerProps> = ({
  startedAt,
  completedAt,
  totalTimeLabel
}) => {
  const initialDatesDiff = useMemo(() =>
    getDatesDifferenceInSeconds(startedAt),
  [startedAt]);

  const {resultTimeHHMMSS: resultTime} =
    useTimer({
      initialDiff: initialDatesDiff,
      initialActive: !!startedAt && !completedAt
    });

  return (
    <div className="value-with-heading">
      <span className="heading">{totalTimeLabel}</span>
      <span className="value">
        {resultTime}
      </span>
    </div>
  );
};

export default ProcessDetailsTimer;
